var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "simple-row" }, [
    _c(
      "div",
      { staticClass: "left" },
      [
        _vm.lableText != null
          ? _c("div", { staticClass: "file-upload-label" }, [
              _vm._v(_vm._s(_vm.lableText))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.assetNatureFlag
          ? _c(
              "div",
              { staticClass: "file-upload-label" },
              [
                _c(
                  "el-select",
                  {
                    attrs: { "collapse-tags": "", placeholder: "请选择" },
                    on: { change: _vm.assetNatureChange },
                    model: {
                      value: _vm.assetNature,
                      callback: function($$v) {
                        _vm.assetNature = $$v
                      },
                      expression: "assetNature"
                    }
                  },
                  _vm._l(_vm.assetNatureList, function(item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.text, value: item.value }
                    })
                  })
                )
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("swb-file-upload", {
          attrs: {
            fileFor: _vm.fileFor,
            custData: _vm.custFileds,
            usage: _vm.usage,
            fileGroup: _vm.fileGroup,
            onBeforeUpload: _vm.onBeforeUpload,
            onProgress: _vm.onProgress,
            onDone: _vm.onUploadDone,
            multipleFile: _vm.multipleFile
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "right" }, [
      _vm.downloadUrl != null ||
      (_vm.downloadFunc != null && typeof _vm.downloadFunc == "function")
        ? _c(
            "a",
            {
              staticClass: "swb-btn swb-btn-link",
              on: { click: _vm.downloadTemplate }
            },
            [_vm._v(_vm._s(_vm.downloadText))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.downloadDescTxt
        ? _c(
            "a",
            {
              staticClass: "swb-btn swb-btn-link",
              on: { click: _vm.downloadDesc }
            },
            [_vm._v("导入说明")]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d1c4ee8c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1c4ee8c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/comn/FileUploadGroupDlg.vue
// module id = 2222
// module chunks = 0